import React from 'react';
import styled from 'styled-components/macro';
import { DeviceSize } from '../basic/DeviceSize';
import Card from '../common/Card';
import { theme } from '../../theme';
import { Button, LinkButton } from '../common';
import { useMessageGetter } from 'react-message-context';
import { NotUrgentPictogram, UrgentPictogram } from '../../assets';
import { Body2 } from '../common/Text';
import { scrollToElement } from '../../utils';
import { getMenuItemPathBySlug } from '../../utils/wordpress';
import { useAppState } from '../../context/appContext';
import { Slugs } from '../../constants/knownSlugs';

const CardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  margin-top: 24px;

  @media ${DeviceSize.mobileL} {
    display: flex;
    flex-direction: column;
  }
`;

const MaintenanceRequests = () => {
  const t = useMessageGetter('');
  const { menu } = useAppState();

  const UrgentButton = (
    <Button onClick={() => scrollToElement('maintenanceContactInfo')} size="medium">
      {t('housing.contacts.callMaintenance')}
    </Button>
  );

  const NonUrgentButton = (
    <LinkButton to={getMenuItemPathBySlug(menu.items, Slugs.FAULT_REPORT)} size="medium">
      {t('housing.reportFault')}
    </LinkButton>
  );

  return (
    <CardContainer>
      <Card
        title={t('housing.contacts.urgentRequest')}
        background={theme().colors.strawberry}
        Pictogram={UrgentPictogram}
        secondaryButton={UrgentButton}
      >
        <Body2>{t('housing.contacts.urgentRequestInfo')}</Body2>
      </Card>
      <Card
        id="notUrgentMaintenanceRequest"
        title={t('housing.contacts.nonurgentRequest')}
        background={theme().colors.lemon}
        Pictogram={NotUrgentPictogram}
        secondaryButton={NonUrgentButton}
      >
        <Body2>{t('housing.contacts.nonurgentRequestInfo')}</Body2>
      </Card>
    </CardContainer>
  );
};

export default MaintenanceRequests;
